module.exports = __webpack_public_path__ + "static/img/turtle_simple.2ee249d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assignments/python/images/turtle_simple.png
// module id = B+Uh
// module chunks = 1